import { useAuth } from '../hooks/useAuth.js';
import { LoginPage } from '../pages/LoginPage.js';

export function AuthGuard({ children }: { children: React.ReactNode }) {
  const { isAuthenticated, isLoading } = useAuth();

  if (isLoading) {
    return (
      <div
        className="flex h-screen w-screen items-center justify-center"
        style={{ background: 'var(--bg-primary)' }}
      >
        <div className="text-sm text-text-dimmed">Loading…</div>
      </div>
    );
  }

  if (!isAuthenticated) {
    const params = new URLSearchParams(window.location.search);
    const error = params.get('auth_error') ?? undefined;
    return <LoginPage error={error} />;
  }

  return <>{children}</>;
}
